import { render, staticRenderFns } from "./UrunPagination.vue?vue&type=template&id=7065c63e&scoped=true"
import script from "./UrunPagination.vue?vue&type=script&lang=js"
export * from "./UrunPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7065c63e",
  null
  
)

export default component.exports